<template>
  <div class="panel">
    <div class="headerPanel">
      <HeaderPanel />
    </div>
    <div class="navbarPanel">
      <NavbarPanel />
    </div>
    <div class="mainDocuments">
      <ItemsMaintenance />
    </div>
  </div>
</template>

<script>
import HeaderPanel from "@/components/panel/HeaderPanel";
import NavbarPanel from "@/components/panel/NavbarPanel";
import ItemsMaintenance from "@/components/panel/kitsMaintenance/ItemsMaintenance";


export default {
  components: {
    HeaderPanel,
    NavbarPanel,
    ItemsMaintenance
  },
};
</script>


<style lang="scss" scoped>
.panel {
  grid-template-areas:
    "header header header"
    "main main main";
  grid-template-columns: 0.7fr 3fr;

  @media (max-width: 440px) {
    grid-template-areas:
      "header header header"
      "main main main";
  }
}

.headerPanel {
  grid-area: header;
}

.navbarPanel {
  grid-area: navbar;
}

.mainDocuments {
  grid-area: main;
}
</style>